import {
  GET_MONTH_REPORT,
  GET_MONTH_REPORT_ERROR,
  GET_MONTH_REPORT_SUCCESS,
} from './MonthlyReport.actions';

const monthlyReportState = {
  data: [],
  m3Production: [],
  monthlyProduction: 0,
  monthlyProductionBefore: 0,
  cycleCount: 0,
  prodHours: [],
  prodHoursIdle: [],
  numberTrucks: [],
  discharge: [],
  wallTime: [],
  avgSpeed: [],
  goodStart: [],
  ending: [],
  startCycle: [],
  breakFast: [],
  trucks: [],
  loadCount: [],
  loadTime: [],
  meanCyclePerTurn: [],
  queueTimes: [],
  heatmapHour: [],
  cycleTime: [],
  m3Moved: [],
  distanceTraveled: [],
  maintenance: [],
  url: '',
  loading: true,
  error: undefined,
  currDate: '',
  currTruck: '',
};

/**
 * The monthly report reducer.
 */

const monthlyReportReducer = (
  state = monthlyReportState,
  { payload, type }
) => {
  switch (type) {
    case GET_MONTH_REPORT_ERROR: {
      return { ...state, loading: false, error: payload.error };
    }
    case GET_MONTH_REPORT: {
      return { ...state, loading: true, error: undefined };
    }
    case GET_MONTH_REPORT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        m3Production: payload.m3Production,
        monthlyProduction: payload.monthlyProduction,
        monthlyProductionBefore: payload.monthlyProductionBefore,
        cycleCount: payload.cycleCount,
        prodHours: payload.prodHours,
        prodHoursIdle: payload.prodHoursIdle,
        numberTrucks: payload.numberTrucks,
        discharge: payload.discharge,
        wallTime: payload.wallTime,
        avgSpeed: payload.avgSpeed,
        goodStart: payload.goodStart,
        ending: payload.ending,
        startCycle: payload.startCycle,
        breakFast: payload.breakFast,
        trucks: payload.trucks,
        loadCount: payload.loadCount,
        loadTime: payload.loadTime,
        meanCyclePerTurn: payload.meanCyclePerTurn,
        queueTimes: payload.queueTimes,
        heatmapHour: payload.heatmapHour,
        cycleTime: payload.cycleTime,
        m3Moved: payload.m3Moved,
        distanceTraveled: payload.distanceTraveled,
        maintenance: payload.maintenance,
        url: payload.url,
        currDate: payload.currDate,
      };
    }
    default: {
      return state;
    }
  }
};

export default monthlyReportReducer;
